const bankDetailsSet = ({ bankName, bankAddress, iban, swift, accountNumber, reference }) => ({
  iban,
  swift,
  reference,
  bank_name: bankName,
  bank_address: bankAddress,
  account_number: accountNumber,
});

export default bankDetailsSet;
